import { watch } from '@vue/composition-api';
import { useStore } from '@/components/composables/useStore';
import { Store } from 'vuex';
import { RootState } from '@/store/Store';
import isEqual from 'lodash/isEqual';

export function watchItems(moduleName: string) {
  const store: Store<RootState> = useStore();

  watch(
    () => store.getters[`${moduleName}/queryFilters`],
    async (newVal, oldVal) => {
      if (!isEqual(newVal, oldVal)) {
        //fetch both items list and total value
        await store.dispatch(`${moduleName}/fetchItems`);
      }
    },
    { immediate: true, deep: true },
  );
}
